import { genderByID, genderCreate, genderDestroy, genderList, genderUpdate } from '@/services/agency/genders.service'

export default {
	namespaced: true,
	state: {
		// SERVICE GENDER
		genderList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		gender: {},

		// STATUS SERVICE GENDER
		genderStatus: 'pending',
		genderSaveStatus: 'init',
		genderDeleteStatus: 'init',
	},
	getters: {
		// SERVICE GENDER
		getGenderList(state) {
			return state.genderList
		},
		getGender(state) {
			return state.gender
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE GENDER
		getGenderDeleteStatus(state) {
			return state.genderDeleteStatus
		},
		getGenderSaveStatus(state) {
			return state.genderSaveStatus
		},
		getGenderStatus(state) {
			return state.genderStatus
		},
	},
	mutations: {
		// SERVICE GENDER
		GENDER_LIST(state, value) {
			state.genderList = value
		},
		SET_GENDER(state, value) {
			state.gender = value
		},

		// STATUS SERVICE GENDER
		GENDER_STATUS(state, value) {
			state.genderStatus = value
		},
		GENDER_SAVE_STATUS(state, value) {
			state.genderSaveStatus = value
		},
		GENDER_DELETE_STATUS(state, value) {
			state.genderDeleteStatus = value
		},
	},
	actions: {
		// Service Gender
		async fetchGenderList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('GENDER_STATUS', 'pending')
			commit('GENDER_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await genderList(params)
				commit('GENDER_STATUS', 'init')
				commit('GENDER_LIST', data)
				return data
			} catch (error) {
				commit('GENDER_STATUS', 'init')
				throw error
			}
		},
		async fetchGenderByID({ commit }, params) {
			commit('GENDER_STATUS', 'pending')
			try {
				const { data } = await genderByID(params)
				commit('GENDER_STATUS', 'init')
				commit('SET_GENDER', data.data)
				return data
			} catch (error) {
				commit('GENDER_STATUS', 'init')

				return error
			}
		},
		async saveNewGender({ commit }, params) {
			commit('GENDER_SAVE_STATUS', 'pending')
			try {
				const { data } = await genderCreate(params)
				commit('GENDER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GENDER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateGender({ commit }, params) {
			commit('GENDER_SAVE_STATUS', 'pending')
			try {
				const { data } = await genderUpdate(params)
				commit('GENDER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GENDER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteGenderByID({ commit }, params) {
			commit('GENDER_DELETE_STATUS', 'pending')
			try {
				const { data } = await genderDestroy(params)
				commit('GENDER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GENDER_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
